var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlHowwework1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1862.5 1141.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6.67px;}.cls-1{stroke:#1af5bc;}.cls-2{stroke:#5c1fde;}.cls-3{fill:#5c1fde;}.cls-4{fill:#1af5bc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.72,570.2v.5c0,263.16,213.51,476.49,476.9,476.49a476.14,476.14,0,0,0,476.9-476.49v-.5h.5a204,204,0,0,1,69.22-152.83h0a204,204,0,0,1,135.52-51.23c112.9,0,204.47,91.32,204.74,204.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,570.2v.5c0,313.22,254.13,567.13,567.62,567.13A568.26,568.26,0,0,0,1104,813h0a560.11,560.11,0,0,0,33.29-89h0a566.93,566.93,0,0,0,21-153.33v-.5h.51a114,114,0,0,1,228,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.1,570.33v.5c0,163.14,132.26,295.4,295.4,295.4A294,294,0,0,0,759.27,813.3a297.07,297.07,0,0,0,69.45-67.76A294,294,0,0,0,885.9,570.83v-.5h.5a386,386,0,0,1,386.1-385.6c213.07,0,385.83,172.59,386.1,385.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.4,570.33v.5c0,213.24,172.86,386.1,386.1,386.1a385.91,385.91,0,0,0,386.1-386.1v-.5h.5a295.33,295.33,0,0,1,126.63-242h0a294,294,0,0,1,168.77-52.93c163,0,295.13,132,295.4,294.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.51,570.33c0,.17,0,.33,0,.5a114,114,0,0,0,228,0c0-.17,0-.33,0-.5H705a568.13,568.13,0,0,1,21-152.94,565.31,565.31,0,0,1,78.67-167.86A567.61,567.61,0,0,1,1272.5,3.33c313.25,0,567.23,253.81,567.5,567"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.8,570.33v.5c0,113,91.65,204.7,204.7,204.7a204.7,204.7,0,0,0,204.7-204.7v-.5h.5A476.69,476.69,0,0,1,1272.5,94c263.16,0,476.53,213.2,476.8,476.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23,
    cy: 527.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.5,
    cy: 527.83,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 203,
    cy: 528.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 295.5,
    cy: 528.83,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 385,
    cy: 529.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 476.5,
    cy: 529.83,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1386,
    cy: 615.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1475.5,
    cy: 615.83,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1566,
    cy: 616.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1658.5,
    cy: 616.83,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1748,
    cy: 617.33,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1839.5,
    cy: 617.83,
    r: 23
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlHowwework1);
export default __webpack_public_path__ + "static/media/il_howwework1.4e9e37be4b1ea39d77e1c9568105bac8.svg";
export { ForwardRef as ReactComponent };